import styled from "styled-components";
// @ts-ignore
import Link from "next/link";
import {IProductListingItem} from "../../interfaces/IProductListingItem";
import TextTruncate from "react-text-truncate";
import Image from "next/legacy/image";
import {useRouter} from "next/router";
import {getNavPath} from "../../shared/navigateUtil";
import {useMessages} from "../../hooks/useMessages";
import {scrollbarTrack} from "../../shared/mixins";
import {getTheme} from "../../shared/themeUtils";
import Badge from "../Badge";

const Box = styled.div`
  border: 1px solid ${getTheme("colors.border")};
  padding: ${getTheme("space.2")};
  border-radius: ${getTheme("borderRadius")};
  margin-top: ${getTheme("space.2")};


  .product-accessory {
    display: flex;
    padding: ${getTheme("space.2")} 0;
    align-items: center;
    border-bottom: 1px solid ${getTheme("colors.border")};
    cursor: pointer;

    &:last-of-type {
      border: none;
      padding-bottom: 0;
    }

    .image {
      min-width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 60px;
        max-height: 60px;
      }
    }
  }

  .product-accessories {
    max-height: 450px;
    overflow: auto;
    padding-right: ${getTheme("space.1")};
    margin-right: ${getTheme("space.1")};

    ${scrollbarTrack}
     
    .product-accessory:first-of-type {
      padding-top: 0;
    }
  }

    .price {
        margin-right: ${getTheme("space.1")};
        margin-bottom: ${getTheme("space.1")};
    }

    .replacement-part {
        font-size: ${getTheme("fontSizes.small")};
        margin-top: ${getTheme("space.0")};
        font-weight: 500;
    }
`

interface AccessoriesBoxProps {
  products: IProductListingItem[]
}

const AccessoriesBox = (props: AccessoriesBoxProps) => {
  const {products} = props;
  const router = useRouter()
  const messagesQuery = useMessages()

  return (
    <Box>
      {messagesQuery.data && <div className="fs-5 mb-3">
        {messagesQuery.data.messages["accessories"]}
      </div>}

      <div className="product-accessories">
        {products.map((product: IProductListingItem) => (
          <Link
            href={getNavPath(router, `p/${product.slug}`)}
            className="product-accessory"
            key={product.productID}>
              <div className="image">
                <Image src={product.image.imageUrl} alt={product.productName} width={"100"} height={"100"} objectFit="contain" />
              </div>
              <div>
                <div>
                  <TextTruncate
                    maxCalculateTimes={0}
                    line={3}
                    element="div"
                    truncateText="…"
                    text={product.productName}
                  />
                </div>
                <div className="fw-bold">
                  <span className={"price"}>{product.currencyPrice}</span>

                  {product.isAccessory && product.isIncluded && messagesQuery.data &&
                    <Badge type={"success"} size={"xSmall"}
                           text={`${product.quantityIncluded} x ${messagesQuery.data.messages["included"]}`}/>

                  }
                </div>

                {product.isReplacementPart && messagesQuery.data &&
                  <div className="replacement-part">
                    {messagesQuery.data.messages["replacement-part"]}
                  </div>
                }
              </div>
          </Link>
        ))}
      </div>
    </Box>
  );
}

export default AccessoriesBox;
